
import { motion } from "framer-motion";
import { useTheme } from "@/contexts/ThemeContext";
import { 
  Instagram, 
  Facebook, 
  Youtube, 
  Music, 
  Play,
  Heart,
  Video,
  Camera,
  Star,
  Share2
} from "lucide-react";

// Heavily optimized MovingParticles Component
export const MovingParticles = () => {
  const { colors } = useTheme();
  
  // Much faster durations and reduced complexity
  const baseDuration = 8; // Faster base duration
  
  // Reduced icon set for better performance
  const icons = [
    { Icon: Instagram, x: 15, y: 25, size: 40, duration: baseDuration },
    { Icon: Facebook, x: 85, y: 15, size: 38, duration: baseDuration + 1 },
    { Icon: Youtube, x: 25, y: 75, size: 42, duration: baseDuration },
    { Icon: Music, x: 75, y: 80, size: 40, duration: baseDuration + 1 },
    { Icon: Play, x: 90, y: 35, size: 36, duration: baseDuration },
    { Icon: Heart, x: 80, y: 60, size: 38, duration: baseDuration },
    { Icon: Video, x: 10, y: 55, size: 40, duration: baseDuration },
    { Icon: Camera, x: 50, y: 90, size: 42, duration: baseDuration },
    { Icon: Star, x: 12, y: 80, size: 38, duration: baseDuration },
    { Icon: Share2, x: 70, y: 25, size: 34, duration: baseDuration }
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {icons.map((item, index) => {
        const IconComponent = item.Icon;
        
        return (
          <motion.div
            key={index}
            className="absolute flex items-center justify-center"
            style={{
              width: item.size,
              height: item.size,
              left: `${item.x}%`,
              top: `${item.y}%`,
            }}
            animate={{
              y: [0, -3, 2, -2, 0], // Reduced movement
              opacity: [0.15, 0.25, 0.2, 0.3, 0.15], // Reduced opacity range
              scale: [1, 1.03, 0.98, 1.02, 1], // Minimal scaling
            }}
            transition={{
              duration: item.duration,
              repeat: Infinity,
              ease: "easeInOut",
              delay: index * 0.2,
            }}
          >
            <IconComponent
              size={item.size}
              style={{
                color: colors.primary,
                filter: `drop-shadow(0 0 2px ${colors.primary}20)`,
              }}
            />
          </motion.div>
        );
      })}
    </div>
  );
};
